// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fQ9HC","content":"styles_content__isdve","mainText":"styles_mainText__DMpVq","highlighted":"styles_highlighted__eFJiy"};